import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import '../node_modules/toastr/build/toastr.min.css';
import App from './App';
import './responsive.css';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js